import AScene from "./AScene.js";

export default class ACanvas
{
    /**
     * @param {AScene} scene 
     */
    constructor(scene, textureName, width, height)
    {
        this.scene = scene;

        if(this.scene.textures.exists(textureName)) this.scene.textures.remove(textureName);
        this.canvas = this.scene.textures.createCanvas(textureName, width, height);
    }

    /**
     * @returns {CanvasRenderingContext2D}
     */
    get context()
    {
        return this.canvas.context;
    }

    static get compositions()
    {
        return {
            SOURCE_OVER: "source-over", SOURCE_IN: "source-in", SOURCE_OUT: "source-out", SOURCE_ATOP: "source-atop", DESTINATION_OVER: "destination-over", DESTINATION_IN: "destination-in", DESTINATION_OUT: "destination-out", DESTINATION_ATOP: "destination-atop", LIGHTER: "lighter", COPY: "copy", XOR: "xor", MULTIPLY: "multiply", SCREEN: "screen", OVERLAY: "overlay", DARKEN: "darken", LIGHTEN: "lighten", COLOR_DODGE: "color-dodge", HARD_LIGHT: "hard-light", SOFT_LIGHT: "soft-light", DIFFERENCE: "difference", EXCLUSION: "exclusion", HUE: "hue", SATURATION: "saturation", COLOR: "color", LUMINOSITY: "luminosity"
        }
    }

    /**
     * @param {string} color omit 0x. Simply a string such as "ff0000"
     */
    addSquare(color, width = -1, height = -1, x = -1, y = -1)
    {
        if(width + height + x + y == -4)
        {
            width = this.context.canvas.width;
            height = this.context.canvas.height;
            x = 0;
            y = 0;
        }
        let rgb = this.hexToRgb(color);
        this.context.fillStyle = "rgb(" + rgb + ")";
        this.context.fillRect(x, y, width, height);
    }

    hexToRgb(hex) 
    {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return parseInt(result[1], 16) + ", " + parseInt(result[2], 16) + ", " +  parseInt(result[3], 16);
    }

    addImage(x, y, key)
    {
        let texture = this.scene.textures.get(key).getSourceImage();
        
        if(texture.constructor.name == "ImageData")
        {
            this.context.putImageData(texture, x, y);
        }
        else
        {
            this.context.drawImage(texture, x, y);
        }
    }

    /**
     * @param {ACanvas.compositions} composition 
     */
    setComposition(composition)
    {
        this.context.globalCompositeOperation = composition;
    }

    saveToTexture(textureName, onComplete)
    {
        // /debugger
        if(this.scene.textures.exists(textureName)) {
            this.scene.textures.remove(textureName);
        }

        var img = document.createElement("img");
        img.src = this.context.canvas.toDataURL("image/png");

        img.addEventListener('load', ()=>{
            this.scene.textures.addImage(textureName, img);
            if(onComplete) onComplete();
        });
    }
}